let _ = require("ES/lib/lodash");
let dd = require("ES/lib/dd");
let esUtils = require("ES/utils/esUtils");
let FormButtons = require("react-loose-forms.bootstrap3/layouts/FormButtons");
let SlideOpenDown = require("../../../../widgets/SlideOpenDown");
let StoriesEditorModal = require("./StoriesEditorModal");
let createStandardEventForm = require("../../createStandardEventForm");
let getSpeakersFromDisplaylists = require("../../../../../utils/getSpeakersFromDisplaylists");
let AuthedUserSession = require("../../../../../utils/AuthedUserSession");
let getListOfSpeakersWhoCanEditMasterStoriesList = require("./getListOfSpeakersWhoCanEditMasterStoriesList");

let mdl = null; //sloppy way to give eventToInitialValues() access to Displaylists

let StoriesToldCheckList = createStandardEventForm({
  eventToInitialValues(event) {

    let Displaylists = mdl; //I'm sure there's a more elegant way to get to this
    let story_ids = _.isString(event.storiesToldList) ? event.storiesToldList.split("|") : [];
    let list_obj;

    //try to translate story ids that were incorrectly stored by their position in alphabetical order
    if (AuthedUserSession.is_st_family) {
      if (AuthedUserSession.is_st_family) {
        list_obj = _.object(_.map(_.get(Displaylists, ["universal", "specific_content_areas", event.companyID], []), function ({id, name}) {
          return [id, name];
        }));
      } else {
      	//have not upgraded to team-admin yet
	      list_obj = _.object(_.map(_.get(Displaylists, ["universal", "specific_content_areas"], []), function ({id, name}) {
          return [id, name];
        }));
      }
    } else {
      list_obj = _.object(_.filter(_.map(_.flattenDeep(_.map(getSpeakersFromDisplaylists(Displaylists, event && event.sids), "stories")), function (story) {
        return _.has(story, "id") && _.has(story, "ti") ? [story.id, story.ti] : null;
      })));
    }
    if (!_.isEmpty(list_obj)) {

      //sort alpha
      var list_obj_alpha = _.sortBy(list_obj, function (o) {
        return o;
      });

      story_ids = _.map(story_ids, function (story_id) {
        if (!_.has(list_obj, story_id)) {
          let story_text = list_obj_alpha[story_id];
          story_id = _.findKey(list_obj, function (item) {
            return (item == story_text);
          });
        }
        return story_id;
      });
      _.remove(story_ids, function (story_id) {
        return !_.has(list_obj, story_id);
      });
    }

    return _.object(_.map(story_ids, function (id) {
      return [id, true];
    }));
  },
  buildSchema({event, Displaylists}) {
    let list_obj;

	  if (AuthedUserSession.is_st_family) {
		  if (AuthedUserSession.is_st_family) {
			  list_obj = _.object(_.map(_.get(Displaylists, ["universal", "specific_content_areas", event.companyID], []), function ({id, name}) {
				  return [id, name];
			  }));
		  } else {
			  //have not upgraded to team-admin yet
			  list_obj = _.object(_.map(_.get(Displaylists, ["universal", "specific_content_areas"], []), function ({id, name}) {
				  return [id, name];
			  }));
		  }
	  } else {
      list_obj = _.object(_.filter(_.map(_.flattenDeep(_.map(getSpeakersFromDisplaylists(Displaylists, event && event.sids), "stories")), function (story) {
        return _.has(story, "id") && _.has(story, "ti") ? [story.id, story.ti] : null;
      })));
    }

    return _.object(_.map(list_obj, function (name, id) {
      return [id, {type: "checkbox", text: name, read_only: false}];
    }));
  },
  writeInputDataToEvent(data, event) {
    event.storiesToldList = _.map(_.filter(_.pairs(data), 1), 0).join("|");
  },
  renderFields() {
    let fields = this.Form_buildSchema();
    let changes_made = this.Form_areChangesMade();
    let {toggleMasterListEditor} = this.props;

    //sort the list of stories by the story title, not the id number
    fields = _.values(fields);
    fields.sort(function (a, b) {
      try {
        return (a.text.toUpperCase() < b.text.toUpperCase()) ? -1 : ((a.text.toUpperCase() > b.text.toUpperCase()) ? 1 : 0);
      } catch (e) {
        return 0;
      }
    });

    return dd.div(null,
      dd.div({className: "panel panel-default storiestold"},
        dd.div({className: "panel-body"},
          dd.table({className: "table table-condensed"},
            dd.thead(null,
              dd.tr(null,
                dd.th({style: {width: 1}},
                  AuthedUserSession.is_st_family
                    ? "Requested"
                    : "Told"
                ),
                dd.th(null,
                  AuthedUserSession.is_st_family
                    ? "Topics"
                    : "Story / Joke"
                )
              )
            ),
            dd.tbody(null,
              _.map(fields, function (field, name) {
                return dd.tr({key: name},
                  dd.td({className: "text-center"},
                    this.Form_buildInput(field)
                  ),
                  dd.td(null,
                    field.text
                  )
                );
              }, this)
            )
          ),
          !_.isEmpty(fields) ? null : dd.div({className: "text-center"},
            dd.div(null,
              AuthedUserSession.is_st_family
                ? "-- no topics --"
                : "-- no stories entered --"
            ),
            toggleMasterListEditor
              ? dd.button({className: "btn btn-primary", onClick: toggleMasterListEditor}, "Add some stories")
              : null
          )
        )
      ),
      SlideOpenDown({open: changes_made},
        FormButtons({onDiscard: this.__discardChanges})
      )
    );
  },
  renderButtons() {
    //we're overriding the standard button render
    //so we can render it inside the renderFields
    return dd.span();
  }
});

module.exports = dd.createClass({
  getInitialState() {
    return {show_master_list_editor: false};
  },
  __toggleMasterListEditor: esUtils.wrapPreventDefault(function () {
    this.setState({show_master_list_editor: !this.state.show_master_list_editor});
  }),
  render() {
    let {event, Displaylists} = this.props;
    let {show_master_list_editor} = this.state;
    let can_I_edit_stories = !_.isEmpty(getListOfSpeakersWhoCanEditMasterStoriesList(Displaylists));
    let toggleMasterListEditor = AuthedUserSession.is_st_family ? null : this.__toggleMasterListEditor;
    mdl = Displaylists;

    return dd.div(null,
      can_I_edit_stories && toggleMasterListEditor ? dd.a({className: "printlink pull-right", onClick: toggleMasterListEditor},
        dd.i({className: "fa fa-gear"}), " Customize Story List"
      ) : null,
      dd.h4({style: {marginBottom: 21}, className: "section-head"},
        AuthedUserSession.is_st_family
          ? "Specific Content Areas"
          : "Stories / Jokes Told"
      ),
      StoriesToldCheckList({event, Displaylists, toggleMasterListEditor}),
      show_master_list_editor && toggleMasterListEditor ? StoriesEditorModal({event, Displaylists, onClose: toggleMasterListEditor}) : null
    );
  }
});



// WEBPACK FOOTER //
// ./src/components/main_view/event_area/tabs/misc/StoriesTold.js